<template>
  <div class="gmf-new-comments-slideshow-container gmf-context" :class="classes">
    <div v-if="this.shouldOpenInSocialModal" class="gmf-new-comments-slideshow-wrapper">
      <a v-for="comment in slicedComments" :key="comment.id" :href="commentUrl(comment)" @click="ev => onClick(ev, comment)">
        <Comment
          avatarView="fullbody"
          :leftColumnAvatar="use3DAvatar"
          :comment="comment"
          voteMode="none"
          :collapse="true"
          :hideReplies="true"
          :elements="{footer: false, title: false, uploads: false, prosAndCons: false, action: true, productImage: true, targetImage: true, target: false, customerLevel: false, stem: false, animateAvatar: true, translateButton: false}"
          :disableTargetLink="true"
        />
      </a>
    </div>
    <div v-else class="gmf-new-comments-slideshow-wrapper">
      <Link v-for="comment in slicedComments" :key="comment.id" :href="commentUrl(comment)">
        <Comment
          avatarView="fullbody"
          :leftColumnAvatar="use3DAvatar"
          :comment="comment"
          voteMode="none"
          :collapse="true"
          :hideReplies="true"
          :elements="{footer: false, title: false, uploads: false, prosAndCons: false, action: true, productImage: true, targetImage: true, target: false, customerLevel: false, stem: false, animateAvatar: true, translateButton: false}"
          :disableTargetLink="true"
        />
      </Link>
    </div>
    <a v-if="!hideButton && shouldOpenInSocialModal" class="gmf-btn gmf-btn-sm gmf-mt-4 gmf-btn-primary" href="#" @click="ev => onClick(ev, null)">{{ t('new_comments_slideshow.show_more') }}</a>
    <a v-else-if="!hideButton && socialFeedUrl" class="gmf-btn gmf-btn-sm gmf-mt-4 gmf-btn-primary" :href="socialFeedUrl">{{ t('new_comments_slideshow.show_more') }}</a>
  </div>
</template>

<style>
.gmf-new-comments-slideshow {
  clear: both;
}
.gmf-context.gmf-new-comments-slideshow-container {
  text-align: center;
  width: 100%;
}
.gmf-comment-body-content, .gmf-comment-content {
  display: inline-flex !important; /* @TODO not important */
  flex-direction: column;
  height: 100%;
}
.gmf-comment-collapse {
  max-height: 100%;
}


.gmf-comment-collapse .gmf-comment-text {
  overflow: hidden;
  flex-grow: 1;
  position: relative;
  font-size: var(--gmf-text-small-font-size);
}

.gmf-comment-collapse .gmf-comment-header {
  display: flex;
  justify-content: center;
  overflow: hidden;
}
.gmf-comment-collapse .gmf-commenter-status {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 16px;
}

.gmf-new-comments-slideshow-wrapper {
  display: flex;
  gap: var(--gmf-object-spacing);

  height: 174px;
  flex-wrap: wrap;
  overflow: hidden;
  text-align: left;
}
.gmf-new-comments-slideshow-wrapper .gmf-comment {
  height: 100%;
  width: 100%;
}
.gmf-new-comments-slideshow-wrapper > a {
    width: 300px;
    display: flex;
    flex-grow: 1;
    height: 100%;
    cursor: pointer;
    text-decoration: none;
}
.gmf-new-comments-slideshow-wrapper .gmf-comment-content-col {
  margin-bottom: 0;
  margin-top: 0;
}
.gmf-new-comments-slideshow .gmf-comment-content {
  justify-content: center;
}
.gmf-new-comments-slideshow-wrapper .gmf-comment-content, .gmf-new-comments-slideshow-wrapper .gmf-comment-body-content {
  width: 100%;
}

.gmf-new-comments-slideshow-wrapper .gmf-comment .gmf-avatar-popout {
  margin-top: 16px;
}


/* hacks for fullbody comment slideshow */
.gmf-new-comments-slideshow-3d .gmf-avatar-3d-fullbody .gmf-status-indicator {
  display: none;
}
.gmf-new-comments-slideshow-3d .gmf-avatar-content {
  z-index: 1;
  pointer-events: none;
}
.gmf-new-comments-slideshow-3d .gmf-comment-customer-col {
  width: 96px;
  padding-top: 20px !important;
}
.gmf-new-comments-slideshow-3d .gmf-comment-content-col {
  margin-left: -16px !important;
}

/* Mobile */
@media only screen and (max-width: 600px) {
  .gmf-new-comments-slideshow-wrapper {
    height: auto;
  }

  .gmf-new-comments-slideshow-3d .gmf-comment-customer-col {
    width: 64px;
    min-height: 120px;
    padding-top: 10px !important;
  }
}
</style>

<script>
/*

voting on/off??
disable replies - NO REPLIES!
some sort of header thingy

*/
import Comment from '@/components/Comment';

import callApi from '@/utils/callApi';

import openSocialModal from '@/widgets/SocialFeed/openSocialModal';

import state from '@/state';

import Link from '@/components/Link';

import elSize from '@/utils/mixins/elSize';


//import state from '../state';

//const t = state.t.prefix('comments');



export default {
  mixins: [elSize],
  props: ['compactMobileView', 'commentType', 'hideButton'],
  components: {
    Comment,
    Link,
  },
  data () {
    return {
      comments: [],
    };
  },
  methods: {
    t: state.t,
    isGoodComment (comment) {
      if (comment.content.images && comment.content.images[0]) {
        return true;
      }
      if (comment.type && comment.type.name === 'site_review' && comment.content.text) {
        return true;
      }
      return (comment.target && comment.target.imageUrl);
    },
    onClick (ev, comment) {
      ev.stopPropagation();
      ev.preventDefault();

      let filter = null;

      if (this.commentType && this.commentType.split(',').length == 1) {
        filter = {
          type: this.commentType,
        };
      }

      openSocialModal({
        scrollToCommentId: comment ? comment.id : null,
        displayHeader: true,
        filter,
      });
      return false;
    },
    commentUrl (comment) {
      if (comment.type.name === 'social_post' || comment.type.name === 'marketplace' || comment.type.name === 'site_review') {
        return this.socialFeedUrl;
      }
      return comment.target.url + '#gmf-comment-section';
    },
  },
  computed: {
    classes () {
      return {
        'gmf-new-comments-slideshow-3d': state.merchantConfig.avatars.enabled === '3D',
      };
    },
    slicedComments () {
      let count = 3;
      if (this.compactMobileView && this.elSize.width < 800) {
        count = 2;
      }
      return this.comments.slice(0, count);
    },
    shouldOpenInSocialModal () {
      const cnf = state.merchantConfig.newCommentsSlideshow;
      return cnf && cnf.linkType === 'social_modal';
    },
    translationsEnabled() {
      return state.merchantConfig?.widgets?.translations.mode !== 'translateNothing';
    },
    socialFeedUrl() {
      return state.merchantConfig?.widgets?.urls?.socialFeed;
    },
    use3DAvatar () {
      return state.merchantConfig.avatars.enabled === '3D';
    },
  },
  async mounted () {
    const query = new URLSearchParams({
      'take': 6,
      'include': 'author',
      'order': 'created.desc',
      'translate': this.translationsEnabled,
      'has_text_content': 1,
      'reply_depth': 0,
      'no_count': 1,
      'link': 'social_post',
    });

    if (! state.merchantConfig?.widgets?.comments?.useNewSearch) {
      query.append('max_age_days', 180);
    }

    const minProductScore = state.merchantConfig.widgets?.newCommentsSlideshow?.minProductScore;
    if (minProductScore > 1) {
      query.append('min_product_score', minProductScore);
    }

    if (this.commentType) {
      const commentTypes = this.commentType.split(',');
      commentTypes.forEach(ct => query.append('type', ct));
    }

    const res = await callApi('GET', state.commentSearchEndpoint + '?'+query.toString());
    const { comments } = await res.json();


    // Simple way to put less focus on "uglier" comments (for example without product image)
    const wantedCount = 3;

    this.comments = [];

    for (const comment of comments) {
      if (this.isGoodComment(comment)) {
        this.comments.push(comment);
      }
      if (this.comments.length >= wantedCount) {
        break;
      }
    }
    for (const comment of comments) {
      if (! this.isGoodComment(comment)) {
        this.comments.push(comment);
      }
      if (this.comments.length >= wantedCount) {
        break;
      }
    }
  },
};
</script>
